import React from 'react';

import BasePane from '@totem/components/BasePane';
import ComponentHeader from '@totem/components/ComponentHeader';
import RemoteAccessDashboardTabs from '@totem/components/services/remoteAccess/dashboard/remoteAccessDashboardTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';

const RemoteAccessDashboardPage = () => {
  return (
    <ContentLayout landingPageName={'remote-access-dashboard'}>
      <BasePane>
        <PrimaryContentPane>
          <ComponentHeader title={'Remote Access'} />
          <div style={{ paddingRight: '32px', paddingLeft: '32px' }}>
            <RemoteAccessDashboardTabs />
          </div>
        </PrimaryContentPane>
      </BasePane>
    </ContentLayout>
  );
};

export default RemoteAccessDashboardPage;
